export default __webpack_public_path__ + "static/media/hawaiian.42d55c8e.png";